var moduleMap = {
	"./config": () => {
		return Promise.all([__webpack_require__.e(123), __webpack_require__.e(834), __webpack_require__.e(359), __webpack_require__.e(961), __webpack_require__.e(845), __webpack_require__.e(30)]).then(() => (() => ((__webpack_require__(7030)))));
	},
	"./hooks": () => {
		return Promise.all([__webpack_require__.e(123), __webpack_require__.e(834), __webpack_require__.e(263), __webpack_require__.e(359), __webpack_require__.e(961), __webpack_require__.e(952), __webpack_require__.e(2), __webpack_require__.e(395)]).then(() => (() => ((__webpack_require__(3002)))));
	},
	"./register": () => {
		return Promise.all([__webpack_require__.e(123), __webpack_require__.e(834), __webpack_require__.e(359), __webpack_require__.e(961), __webpack_require__.e(952), __webpack_require__.e(845), __webpack_require__.e(347)]).then(() => (() => ((__webpack_require__(6347)))));
	},
	"./game-picker": () => {
		return Promise.all([__webpack_require__.e(123), __webpack_require__.e(263), __webpack_require__.e(674), __webpack_require__.e(359), __webpack_require__.e(961), __webpack_require__.e(358), __webpack_require__.e(298), __webpack_require__.e(822)]).then(() => (() => ((__webpack_require__(4822)))));
	},
	"./app-sidebar": () => {
		return Promise.all([__webpack_require__.e(123), __webpack_require__.e(834), __webpack_require__.e(263), __webpack_require__.e(674), __webpack_require__.e(82), __webpack_require__.e(359), __webpack_require__.e(961), __webpack_require__.e(952), __webpack_require__.e(358), __webpack_require__.e(2), __webpack_require__.e(298), __webpack_require__.e(678)]).then(() => (() => ((__webpack_require__(9678)))));
	}
};
var get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = (shareScope, initScope) => {
	if (!__webpack_require__.S) return;
	var name = "default"
	var oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});